"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ScopesCache = _interopRequireDefault(require("../utils/ScopesCache"));

var _default = function _default() {
  var scopesToMatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (_ref) {
    var scopes = _ref.scopes;
    var scopesMap = (0, _ScopesCache.default)(scopes);
    return scopesToMatch.some(function (scope) {
      return scope in scopesMap;
    });
  };
};

exports.default = _default;
module.exports = exports.default;